import { TABLET_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import styled from "styled-components";

export const RatingWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	column-gap: 1.5rem;
	row-gap: 0.5rem;

	@media only screen and (max-width: ${TABLET_BP}px) {
		justify-content: space-evenly;
		.separator {
			display: none;
		}
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: min-content;

	@media only screen and (max-width: ${TABLET_BP}px) {
		align-items: center;
	}
`;

export const Reviews = styled.a`
	color: var(--primary-neutral-nightshade-600);
	font-family: var(--ff-haffer-xh);
	font-size: var(--fs-0);
	font-weight: var(--fw-haffer-xh-1);
	line-height: var(--lh-4);
	text-align: left;
	margin-top: 8px;
	text-decoration: none;
	white-space: nowrap;

	.reviewCount {
		all: inherit;
		display: inline-block;
		margin: 0;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		.reviewCount {
			display: none;
		}
	}
`;

export const Underline = styled.span`
	all: inherit;
	display: inline-block;
	margin: 0;
	margin-right: 0.25rem;
	font-weight: var(--fw-haffer-xh-2);
	text-decoration: underline;
`;
